export const OPEN_QNA_EVENT = "open-qna";
export const OPEN_HELPDESK_ARTICLE_EVENT = "open-helpdesk-article";
export const OPEN_HELPDESK_CONVERSATION_EVENT = "open-helpdesk-conversation";
export const TOGGLE_INTERCOM_EVENT = "toggle-intercom";
export const CROSS_MEETING_SUMMARY_REGENERATED_EVENT = "cross-meeting-summary-regenerated";
export const TRANSCRIPT_EDITED_EVENT = "transcript-edited";
// The rc:-prefixed events bridge the legacy host, which binds on `document`, not `window`.
export const TRANSCRIPT_RENDERED_EVENT = "rc:transcript-rendered";
export const TRANSCRIPT_REVEALED_EVENT = "rc:transcript-revealed";
export const TRANSCRIPT_HIGHLIGHTS_EVENT = "rc:transcript-highlights";
export const dispatchOpenQnA = (context) => {
    window.dispatchEvent(new CustomEvent(OPEN_QNA_EVENT, { detail: context }));
};
export const dispatchOpenHelpdeskArticle = (payload) => {
    window.dispatchEvent(new CustomEvent(OPEN_HELPDESK_ARTICLE_EVENT, { detail: payload }));
};
export const dispatchOpenHelpdeskConversation = (payload) => {
    window.dispatchEvent(new CustomEvent(OPEN_HELPDESK_CONVERSATION_EVENT, { detail: payload }));
};
export const dispatchToggleIntercom = () => {
    window.dispatchEvent(new CustomEvent(TOGGLE_INTERCOM_EVENT));
};
export const dispatchCrossMeetingSummaryRegenerated = (payload) => {
    window.dispatchEvent(new CustomEvent(CROSS_MEETING_SUMMARY_REGENERATED_EVENT, { detail: payload }));
};
export const dispatchTranscriptEdited = (payload) => {
    window.dispatchEvent(new CustomEvent(TRANSCRIPT_EDITED_EVENT, { detail: payload }));
};
export const dispatchTranscriptRendered = () => {
    document.dispatchEvent(new CustomEvent(TRANSCRIPT_RENDERED_EVENT));
};
export const dispatchTranscriptRevealed = () => {
    document.dispatchEvent(new CustomEvent(TRANSCRIPT_REVEALED_EVENT));
};
